const SearchBox = () =>
	import(
		/* webpackChunkName: "component-search-box" */ "@/components/search-box"
	);
const Account = () =>
	import(
		/* webpackChunkName: "component-search-box" */ "@/components/account"
	);
import { getHeaderHeight } from "@/common/functions";
import { mapState } from "vuex";

export default {
	name: "Header",
	components: {
		SearchBox,
		Account,
	},
	data() {
		return {
			searchFocus: false,
			searchEnabled: false,
			menu: [
				{
					linkText: this.$t("WordscapesHeaderEnWfText"),
					logoSpriteClass: "wf",
					ariaLabel: this.$t("WordscapesHeaderEnWfAriaLabel"),
					title: this.$t("WordscapesHeaderEnWfTitleAttribute"),
					url: this.$t("WordscapesHeaderEnWfUrl"),
					eventAction: "Click on EN WF logo",
					imageURL: "/static/images/ic-ws_wf.png",
					imageURLWebp: "/static/images/ic-ws_wf.webp",
				},
				{
					linkText: this.$t("WordscapesHeaderYdrText"),
					logoSpriteClass: "yd",
					ariaLabel: this.$t("WordscapesHeaderYdrAriaLabel"),
					title: this.$t("WordscapesHeaderYdrTitleAttribute"),
					url: this.$t("WordscapesHeaderYdrUrl"),
					eventAction: "Click on YDR logo",
					imageURL: "/static/images/ic-ws_yd.png",
					imageURLWebp: "/static/images/ic-ws_yd.webp",
				},
			],
			lastScrollPosition: 0,
			currentHeaderPosition: 0,
		};
	},
	computed: {
		...mapState({
			topAdHeight: (state) => state.domElements.topAdHeight,
		}),
		logoVisibility() {
			if (this.isSmallDevice && this.searchFocus) return false;
			return true;
		},
		isOnScreenScroll() {
			return this.$store.state.window.scrollY > 0;
		},
		headerScrollOffset() {
			const scrollPosition = this.$store.state.window.scrollY;

			if (!this.isOnScreenScroll || !this.isSmallDevice) {
				return { top: `${this.topAdHeight}px` };
			}

			let direction = this.lastScrollPosition - scrollPosition;
			this.lastScrollPosition = scrollPosition;

			this.isScrollingDownwards(direction)
				? this.calculateScrollingDownwardsOffset(direction)
				: this.calculateScrollingUpwardsOffset(direction);

			this.$store.commit("setHeaderOffset", this.currentHeaderPosition);

			return { top: `${this.currentHeaderPosition}px` };
		},
	},
	methods: {
		onInput(query) {
			this.searchEnabled = query.length > 0 ? true : false;
		},
		handleClick(eventAction) {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Header",
				eventAction: eventAction,
			});
		},
		handleLogoClick() {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Header",
				eventAction: "Click on Wordscapes logo",
			});
		},
		isScrollingDownwards(direction) {
			return direction < 0;
		},
		calculateScrollingDownwardsOffset(direction) {
			const headerHeight = getHeaderHeight(this.isSmallDevice);
			this.currentHeaderPosition = this.currentHeaderPosition + direction;

			if (this.currentHeaderPosition < -headerHeight) {
				this.currentHeaderPosition = -headerHeight;
			}
		},
		calculateScrollingUpwardsOffset(direction) {
			const adHeight = this.topAdHeight;
			this.currentHeaderPosition = this.currentHeaderPosition + direction;

			if (this.currentHeaderPosition > adHeight) {
				this.currentHeaderPosition = adHeight;
			}
		},
	},
	mounted() {
		this.$store.commit("setHeaderHeight", this.$refs.header.clientHeight);
	},
};
